module.exports = __webpack_public_path__ + "static/media/yak.68071a0c.png";